import React from "react";
import ViewReverse from "../../components/ViewReverse";
import Text from "../../components/Text";
import { fontSizes, pdfsPath } from "../../constants/constants";
import dynamicfunction from "../../utils/dynamicfunction";
import { ReactSVG } from "react-svg";
import icons from "../../constants/icons";
import {
  termsAndConditions,
  termsAndConditionsArabic,
} from "../../config/config";
import ViewItems from "../../components/ViewItems";

const Terms = () => {
  const { TextWeight, isArabic } = dynamicfunction();

  const content = isArabic ? termsAndConditionsArabic : termsAndConditions;

  return (
    <div className="container mx-auto">
      <ViewReverse className={"w-full justify-between items-center"}>
        <Text
          text={content?.heading}
          color="text-primary"
          size={fontSizes.h24}
          weight={TextWeight.bold}
        />

        <a
          href={pdfsPath.terms_conditions}
          download={pdfsPath.terms_name}
        >
          <ViewReverse className={"gap-2 cursor-pointer"}>
            <ReactSVG src={icons.cloud} />
            <Text
              text={content?.download}
              color="text-primary"
              size={fontSizes.h14}
            />
          </ViewReverse>
        </a>
      </ViewReverse>

      <Text
        text={content?.description}
        className={"mt-4"}
        size={fontSizes.h14}
      />

      {content?.content?.map((item, index) => (
        <ViewItems key={index} className={"mt-8"}>
          <Text
            text={item.title}
            size={fontSizes.h16}
            color="text-primary"
            weight={TextWeight.bold}
          />
          <Text
            text={item.content}
            size={fontSizes.h14}
            className={"mt-3"}
            style={{ whiteSpace: "pre-line" }}
          />
        </ViewItems>
      ))}
    </div>
  );
};

export default Terms;
